"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MorningStar_1 = __importDefault(require("./MorningStar"));

exports.default = MorningStar_1.default;